import React from "react";
import Contact from "../contact/Contact";


export default function Profile() {
   
    return <Contact />;
  }

